export const ACCESSIBLE = 'ACC0000000002';
export const VALET_PARKING = 'ACC0000000003';
export const TRANSLATION = 'ACC0000000004';
export const AMERICAN_SIGN_LANGUAGE = 'ACC0000000005';
export const PARKING = 'ACC0000000006';